import React, { useContext, useEffect, useState } from 'react';
import { getTenantTerminologyBaseResources } from '../../../../TranslationResources/services/api-calls';
import { TenantIdContext } from '../../../../../components/app/App';
import { StepEditor } from './StepEditor';
import Select, { SelectOption } from '@amzn/meridian/select';

const TB_EDIT_HEADER = 'Edit Terminology Base:';
const TB_MODELS_LABEL = 'Terminology Base Table';

export const TerminologyBaseEditor = ({ subWorkflow, node, onAccept, onCancel }) => {
  const tenantId = useContext(TenantIdContext);
  const [tbResources, setTbResources] = useState([]);
  const [header, setHeader] = useState(TB_EDIT_HEADER);
  const [selectedTb, setSelectedTb] = useState(null);

  useEffect(() => {
    setHeader(`${TB_EDIT_HEADER} ${subWorkflow.sourceLocale} to ${subWorkflow.targetLocale}`);
    getTenantTerminologyBaseResources({ tenantId: tenantId }).then(response => {
      setTbResources(
        response.data.map((entry, index) => {
          return {
            ...entry['resourceData'],
            resourceId: entry['resourceSk'],
          };
        })
      );
    });
  }, [node, subWorkflow, tenantId]);

  useEffect(() => {}, [node]);

  useEffect(() => {
    if (tbResources === null || tbResources.length === 0) {
      return;
    }

    for (const [index, resource] of tbResources.entries()) {
      if (resource.resourceId === node.parameters.resourceId) {
        setSelectedTb(index);
        return;
      }
    }
  }, [tbResources, node]);

  const handleAcceptClicked = () => {
    const tbResource = tbResources[selectedTb];
    node.parameters.tableName = tbResource.tbTableName;
    node.parameters.termIdentifier = tbResource.termIdentifier;
    node.parameters.roleArn = tbResource.roleArn;
    node.parameters.resourceId = tbResource.resourceId;
    onAccept();
  };

  const updateSelections = value => {
    setSelectedTb(value);
  };

  return (
    <StepEditor
      modalHeader={header}
      onAccept={handleAcceptClicked}
      onCancel={onCancel}
      initialRoleArn={node.parameters.roleArn}
    >
      <div>
        <div>
          <label>{TB_MODELS_LABEL}</label>
          <Select value={selectedTb} onChange={updateSelections} placeholder="Select a translation memory table">
            {tbResources &&
              tbResources.map((resource, resourceIndex) => {
                let label = resource.tbTableName;
                if (resource.termIdentifier) {
                  label = `${resource.tbTableName}: ${resource.termIdentifier} [${resource.awsAccountId}]`;
                }
                return <SelectOption value={resourceIndex} key={resourceIndex} label={label} />;
              })}
          </Select>
        </div>
      </div>
    </StepEditor>
  );
};
